export var ShiftingType;
(function (ShiftingType) {
    ShiftingType["REAL"] = "real";
    ShiftingType["ZONE"] = "zone";
    ShiftingType["NONE"] = "none";
})(ShiftingType || (ShiftingType = {}));
//# sourceMappingURL=ShiftingType.js.map